var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view create-profile"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"box"},[_c('CreateProfileForm')],1)])])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }